import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../../../FeaturedTable/FeaturedTable'
import { getClients } from '../../../../reducers/clientsReducer'
import { setSelectedRequest } from '../../../../reducers/maintenanceReducer'
import { getColumns } from '../helpers'

const MaintenanceRequestsList = ({
  setSortBy,
  sortBy,
  setSelectedRequest,
  requests,
  isLoading,
  isYardiProperty,
  timezone,
}) => {
  const { t } = useTranslation(['maintenance'])
  const handleColumnClick = (column) => {
    if (column.id === 'Date') {
      if (sortBy === 'ASC') setSortBy('DESC')
      if (sortBy === 'DESC') setSortBy('ASC')
    }
  }

  return (
    <div
      className={`ctp-maintenance-requests-list ctp-guests-residents-list ${
        isLoading ? 'is-loading' : ''
      }`}
    >
      {!isLoading && requests.length ? (
        <FeaturedTable
          onColumnClick={handleColumnClick}
          onCellClick={({ row }) => setSelectedRequest(row.original)}
          data={requests}
          columns={getColumns(t, isYardiProperty, timezone)}
        />
      ) : (
        !isLoading && !requests.length && t('maintenance:requests.list.noRequestsYet')
      )}
    </div>
  )
}

MaintenanceRequestsList.propTypes = {
  requests: PropTypes.array.isRequired,
  staffPersons: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  clients: PropTypes.array,
  getClients: PropTypes.func.isRequired,
  sortBy: PropTypes.string.isRequired,
  setSortBy: PropTypes.func.isRequired,
  setSelectedRequest: PropTypes.func.isRequired,
  isYardiProperty: PropTypes.bool,
  timezone: PropTypes.string,
}

export default connect(() => ({}), { getClients, setSelectedRequest })(MaintenanceRequestsList)
